module.exports = __webpack_public_path__ + "static/img/manual-39.7297ba0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-39.png
// module id = h7zz
// module chunks = 4